import { IOptions } from '@featbit/react-client-sdk'

export const FEATURE_FLAGS_OPTIONS: IOptions = {
  sdkKey: process.env.REACT_APP_FEATURE_FLAGS_SECRET ?? '',
  streamingUri: `${process.env.REACT_APP_FEATURE_FLAGS_URL?.replace('https://', 'wss://')}/els`,
  eventsUri: `${process.env.REACT_APP_FEATURE_FLAGS_URL}/els`,
}

export const FEATURE_FLAG_USER_PREFIX = 'hagerAuth'
export const FEATURE_FLAG_AUTH_TYPE = 'hagerAuth'
export const FEATURE_FLAG_E3DC_USER_BRAND_TYPE = 'e3dc'
